/**
 * API Configuration
 * Single source of truth for backend URL
 * Ensures consistent API base URL across all components
 */

// Get backend URL from environment variable
// Fall back to empty string if not set (which would use relative URLs)
const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || '';

// Remove trailing slash if present
export const getApiBaseUrl = () => {
  return API_BASE_URL.replace(/\/$/, '');
};

// Export for direct use
export const API_BASE = getApiBaseUrl();

// Helper function to build API URLs
export const buildApiUrl = (path) => {
  const base = getApiBaseUrl();
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${base}${cleanPath}`;
};

export default {
  API_BASE,
  getApiBaseUrl,
  buildApiUrl
};
